import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const INDETERMINATE_MAX = Infinity;

/*
Displays the paginator range string in the format of "{minPageAmount} - {maxPageAmount} of many".
Useful for APIs that don't return the full total results amount in the API response.
NOTE: adding this as a provider in common modules will cause the paginator to behave this way in any
components that import that module, which is probably not desired.
*/
@Injectable()
export class MatPaginatorOfManyDisplayed extends MatPaginatorIntl {
  private ofTranslated = signal('of'); // Default fallback
  private ofManyTranslated = signal('of many'); // Default fallback

  constructor(public readonly translateService: TranslateService) {
    super();
    this.initializeTranslations();
  }

  private initializeTranslations(): void {
    this.translateService
      .stream(['PAGINATOR.OF', 'PAGINATOR.OF_MANY'])
      .pipe()
      .subscribe((translations) => {
        this.ofTranslated.set(translations['PAGINATOR.OF']);
        this.ofManyTranslated.set(translations['PAGINATOR.OF_MANY']);

        this.changes.next(); // Notify paginator to update labels
      });
  }

  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofTranslated()} ${length}`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    // check whether to use "of many" rather than "of length"
    return `${startIndex + 1} - ${endIndex} ${
      length === INDETERMINATE_MAX ? this.ofManyTranslated() : this.ofTranslated() + ' ' + length
    }`;
  };
}
